// eslint-disable-next-line jira/filename-case
import React, { useContext, useEffect } from 'react';
import noop from 'lodash/noop';
import log from '@atlassian/jira-common-util-logging/src/log.tsx';
import Context, { type ExperienceContext } from '../../common/context/index.tsx';
import type { TrackerProps } from '../../common/types.tsx';
import TrackerBase from './TrackerBase.tsx';

export const ExperienceTracker = ({
	children = null,
	location,
	failureEventAttributes = null,
	parentProviders = null,
}: TrackerProps): React.JSX.Element | null => {
	const context: ExperienceContext | null = useContext(Context);
	useEffect(() => {
		if (context === null) {
			log.safeErrorWithoutCustomerData(
				'experience-tracker.missing-provider',
				'Experience tracker rendered without a provider',
			);
		}
	}, [context]);
	if (context == null || __SERVER__) {
		return typeof children === 'function' ? (
			children({
				onExperienceSuccess: noop,
				onExperienceFailure: noop,
				onExperienceAbort: noop,
			})
		) : (
			<>{children}</>
		);
	}
	return (
		<TrackerBase
			experienceTrackerId={location}
			location={location}
			experienceContext={context}
			failureEventAttributes={failureEventAttributes}
			parentProvidersWhitelist={parentProviders}
		>
			{children}
		</TrackerBase>
	);
};
